import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { CartProvider } from '../context/CartContext';
import CartDrawer from '../components/CartDrawer';
import '../styles/pundit-theme.css'
import Navbar from '../components/Navbar'; // Import Navba
const PunditPurohitLayout = () => {
  return (
    <CartProvider>
      <Navbar /> {/* Stays on every page */}
      <CartDrawer />
      <Link to="/2.0" className="floating-uc-explore-btn">
        <span className="floating-uc-mark">UC</span>
        <span className="floating-uc-copy">
          <strong>Explore</strong>
          <small>Udyog Connect</small>
        </span>
      </Link>
      <div style={{ marginTop: '70px' }}> {/* Prevents content from being hidden under fixed nav */}
        <Outlet />
      </div>
    </CartProvider>
  );
};
export default PunditPurohitLayout;
